import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React, { Ref, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { clearChangedTimeEntries } from 'features/pending-timesheets/redux/time-entries-slice';
import { TypedLocalState } from 'utils/redux-hooks';

export interface IAppModalProps {
    header: JSX.Element;
    footer: JSX.Element;
    children: React.ReactNode;
    isOpen: boolean;
    close: () => void;
    size?: string;
    className?: string;
    headerClassName?: string;
    bodyClassName?: string;
    footerClassName?: string;
    innerRef?: Ref<HTMLElement>;
}

const AppModal = (props: IAppModalProps): JSX.Element => {
    const {
        headerClassName,
        bodyClassName,
        footerClassName,
        isOpen,
        close,
        size,
        className,
        innerRef,
        children,
        header,
        footer,
    } = props;

    const [modalVisible, setModalVisible]: TypedLocalState<boolean> = useState(isOpen);
    const dispatch = useDispatch();

    const closeModal = (): void => {
        close();
        setModalVisible(false);
        dispatch(clearChangedTimeEntries());
    };

    useEffect(() => {
        setModalVisible(isOpen);
    }, [isOpen]);

    return (
        <Modal
            isOpen={modalVisible}
            toggle={closeModal}
            centered={true}
            size={size}
            className={className}
            labelledBy="dialogheader"
            innerRef={innerRef ? innerRef : null}
        >
            <ModalHeader toggle={closeModal} id="dialogheader" className={headerClassName}>
                {header}
            </ModalHeader>
            <ModalBody className={bodyClassName}>
                <span className="text-style-5">{children}</span>
            </ModalBody>
            <ModalFooter className={footerClassName}>{footer}</ModalFooter>
        </Modal>
    );
};

export default AppModal;
